export default __webpack_public_path__ + "static/media/gmg_ColorCard_logo.61191247.svg";